import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/new/ico_ticket_2 1.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-4baa2d37"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "game-panel" };
var _hoisted_2 = { class: "game-panel-inner" };
var _hoisted_3 = { class: "leaderboard" };
var _hoisted_4 = { class: "content-wrap" };
var _hoisted_5 = { class: "content" };
var _hoisted_6 = /*#__PURE__*/ _createStaticVNode("<div class=\"col-12 col-md-12 col-xs-12\" data-v-4baa2d37><div class=\"col-np-6 col-np-md-12 col-np-xs-12\" data-v-4baa2d37><div class=\"texts-wrap\" data-v-4baa2d37><span class=\"home-title-head font-ang\" data-v-4baa2d37>Miner&#39;s Rush</span><span class=\"home-title font-ang\" data-v-4baa2d37>Shop</span></div></div><div class=\"col-6\" data-v-4baa2d37></div></div>", 1);
var _hoisted_7 = { class: "col-12 col-md-12 col-xs-12" };
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "col-np-9 col-np-md-12 col-np-xs-12 ticket-descr" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "main-text" }, " Join the exclusive Miner's Rush Tournament with this unique NFT ticket! Dive deep into the heart of the mines and compete against other players for exciting rewards. Burn this ticket to enter a daily tournament level where your skills will be put to the test. "),
    /*#__PURE__*/ _createElementVNode("p", { class: "mobile-hide" }, " Aim for the top spots to claim real money prizes, or secure your place and receive valuable in-game goodies. Don't miss out on this thrilling opportunity to prove your mining prowess! ")
], -1); });
var _hoisted_9 = { class: "col-np-3 col-np-md-12 col-np-xs-12" };
var _hoisted_10 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "col-np-12 col-np-md-7 col-np-xs-6 desktop-hide ticket-descr" }, [
    /*#__PURE__*/ _createElementVNode("p", null, " Aim for the top spots to claim real money prizes, or secure your place and receive valuable in-game goodies. Don't miss out on this thrilling opportunity to prove your mining prowess! ")
], -1); });
var _hoisted_11 = { class: "col-np-12 col-np-md-5 col-np-xs-6" };
var _hoisted_12 = { class: "ticket-wrap" };
var _hoisted_13 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_14 = { class: "col-12 col-md-12 col-xs-12" };
var _hoisted_15 = { class: "panel with-header" };
var _hoisted_16 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "shop-title" }, "Gold Shop", -1); });
var _hoisted_17 = { class: "panel-content shop-content-coins" };
var _hoisted_18 = { class: "col-4 col-md-12 col-xs-12 shop-item" };
var _hoisted_19 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "shop-image shop-BRONZE" }, null, -1); });
var _hoisted_20 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "shop-value font-ang" }, [
    /*#__PURE__*/ _createTextVNode("100"),
    /*#__PURE__*/ _createElementVNode("span")
], -1); });
var _hoisted_21 = { class: "col-4 col-md-12 col-xs-12 shop-item" };
var _hoisted_22 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "shop-image shop-SILVER" }, null, -1); });
var _hoisted_23 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "shop-value font-ang" }, [
    /*#__PURE__*/ _createTextVNode("550"),
    /*#__PURE__*/ _createElementVNode("span")
], -1); });
var _hoisted_24 = { class: "col-4 col-md-12 col-xs-12 shop-item" };
var _hoisted_25 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "shop-image shop-GOLD" }, null, -1); });
var _hoisted_26 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "shop-value font-ang" }, [
    /*#__PURE__*/ _createTextVNode("1150"),
    /*#__PURE__*/ _createElementVNode("span")
], -1); });
var _hoisted_27 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "shop-notif" }, " When transaction will be confirmed, you'll see your assets in Profile ", -1); });
var _hoisted_28 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "top-divider" }, null, -1); });
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                            _hoisted_8,
                            _createElementVNode("div", _hoisted_9, [
                                _hoisted_10,
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _hoisted_13,
                                        _createElementVNode("div", {
                                            class: "shop-buy-btn",
                                            onClick: _cache[0] || (_cache[0] = function ($event) { return ($options.buy('ticket')); })
                                        }, "0.1 CORE")
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _hoisted_16,
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _hoisted_19,
                                        _hoisted_20,
                                        _createElementVNode("span", {
                                            class: "shop-buy-btn",
                                            onClick: _cache[1] || (_cache[1] = function ($event) { return ($options.buy('coins100')); })
                                        }, "0.1 CORE")
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                        _hoisted_22,
                                        _hoisted_23,
                                        _createElementVNode("span", {
                                            class: "shop-buy-btn",
                                            onClick: _cache[2] || (_cache[2] = function ($event) { return ($options.buy('coins550')); })
                                        }, "0.5 CORE")
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                        _hoisted_25,
                                        _hoisted_26,
                                        _createElementVNode("span", {
                                            class: "shop-buy-btn",
                                            onClick: _cache[3] || (_cache[3] = function ($event) { return ($options.buy('coins1150')); })
                                        }, "1 CORE")
                                    ]),
                                    _hoisted_27
                                ])
                            ])
                        ])
                    ])
                ]),
                _hoisted_28
            ])
        ])
    ]));
}
